import { HttpQueryConfig } from '../../core/model/HttpQueryConfig.model';

export const L3ServicesHttpQuery: HttpQueryConfig = {
  GetL3Services: {
    key: 'GetL3Services',
    url: '/api/customers/{customerId}/l3-services',
    errors: {},
  },
};
